/** @jsxImportSource react */
/** @jsxFactory React.createElement */
/** @jsxFragmentFactory React.Fragment */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';
import Config from './config';

if (process.env.REACT_APP_ENV === 'production') {
	console.log('production detected, initializing sentry');
	Sentry.init({
		dsn: 'https://43cd0d80534548e2b1950f656b3fd172@o505316.ingest.sentry.io/4503936998768640',
		environment: 'drawing-v2',
	});
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (window.location.search.includes('config=true')) {
	root.render(
		<React.StrictMode>
			<Config />
		</React.StrictMode>
	);
} else {
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	);
}
